/* eslint-disable unicorn/number-literal-case */
/* eslint-disable react-dom/no-dangerously-set-innerhtml */
/* eslint-disable react-refresh/only-export-components */

// locale 到货币 ISO 代码的映射
const LOCALE_CURRENCY_MAP: Record<string, string> = {
  en: 'USD', // 英语 - 美元
  zh: 'CNY', // 简体中文 - 人民币
  tw: 'TWD', // 繁体中文 - 新台币
  th: 'THB', // 泰语 - 泰铢
  it: 'EUR', // 意大利语 - 欧元
  pl: 'PLN', // 波兰语 - 兹罗提
  tr: 'TRY', // 土耳其语 - 里拉
  fr: 'EUR', // 法语 - 欧元
  ko: 'KRW', // 韩语 - 韩元
  de: 'EUR', // 德语 - 欧元
  ja: 'JPY', // 日语 - 日元
  ru: 'RUB', // 俄语 - 卢布
  pt: 'BRL', // 葡萄牙语 - 巴西雷亚尔
  ar: 'SAR', // 阿拉伯语 - 沙特里亚尔
  nb: 'NOK', // 挪威语 - 挪威克朗
  nl: 'EUR', // 荷兰语 - 欧元
  da: 'DKK', // 丹麦语 - 丹麦克朗
  es: 'EUR', // 西班牙语 - 欧元
  id: 'IDR', // 印尼语 - 印尼盾
}

export function getCurrencyByLocale(locale: string): string {
  return LOCALE_CURRENCY_MAP[locale] || 'USD'
}
function hashString(str: string): number {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) | 0
  }
  return Math.abs(hash)
}

function createSeededRandom(seed: number): () => number {
  let s = seed | 0
  return () => {
    s = (s + 0x6d2b79f5) | 0
    let t = Math.imul(s ^ (s >>> 15), 1 | s)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
export function generateRatingData(
  priceCurrency: string,
  pagePath: string,
): IRatingData {
  const random = createSeededRandom(hashString(pagePath))

  const ratingMin = 4.5
  const ratingMax = 4.9
  const ratingValue = (ratingMin + random() * (ratingMax - ratingMin)).toFixed(
    1,
  )

  const countMin = 10000
  const countMax = 5000000
  const reviewCount = Math.floor(
    countMin + random() * (countMax - countMin),
  ).toString()

  return {
    ratingValue,
    reviewCount,
    priceCurrency,
  }
}

export interface IRatingData {
  ratingValue: string
  reviewCount: string
  priceCurrency: string
}
interface JsonLdProps {
  name: string
  description: string
  origin: string
  ratingValue: string
  reviewCount: string
  priceCurrency: string
}

export default function RatingStructured({
  name,
  description,
  origin,
  ratingValue,
  reviewCount,
  priceCurrency,
}: JsonLdProps) {
  const Rating = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    'url': origin,
    'operatingSystem': 'Windows, Mac, Linux, Android, iOS',
    'applicationCategory': 'BusinessApplication',
    'aggregateRating': {
      '@type': 'AggregateRating',
      'worstRating': '1',
      'bestRating': '5',
      ratingValue,
      reviewCount,
    },
    'offers': {
      '@type': 'Offer',
      'price': '0',
      priceCurrency,
    },
  })

  return (
    <script
      id='Rating'
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: Rating }}
    />
  )
}
